/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-extra-boolean-cast */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Icon, Grid } from 'semantic-ui-react';
import styled from 'styled-components';
import moment from 'moment';

import { StyledTitleContainer } from 'components/Layout';

const StyledDateContainer = styled.div`
    display:inline-block;
    float: right;
`;
export class Infobox extends Component {
  static propTypes = {
    processoImprese: PropTypes.object,
  };

  state = {
    activeIndex: null,
  }


  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }


  render() {
    if (!this.props.processoImprese) {
      return null;
    }

    const { activeIndex } = this.state;

    return (
      <Accordion fluid styled style={{ marginBottom: 15, backgroundColor: '#F3F4F5', color: '#999' }}>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          style={{ position: 'relative', paddingLeft: 25, fontSize: '.9em' }}
          onClick={this.handleClick}
        >
          <Icon name="dropdown" />
          <StyledTitleContainer>
            <b style={{ textTransform: 'Uppercase', color: '#666' }}>CODICE PRATICA: {this.props.processoImprese.codice} </b>
          </StyledTitleContainer>
          <StyledDateContainer>
            <b style={{ textTransform: 'Uppercase', color: '#666' }}>CREATA IL</b> {moment.unix(this.props.processoImprese.createdAt).format('DD/MM/YYYY')}
          </StyledDateContainer>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <Grid style={{ borderTop: '1px solid #ccc', marginTop: -6, fontFamily: 'Lato, Helvetica' }}>
            <Grid.Row>
              <Grid.Column width={16}><b style={{ color: '#666' }}>COLLABORATORE: </b> {this.props.processoImprese.nominativoCollaboratore || '--'}</Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginTop: -18 }}>
              <Grid.Column width={16}><b style={{ color: '#666' }}>PROFILO COLLABORATORE: </b> {this.props.processoImprese.profiloCollaboratore ? this.props.processoImprese.profiloCollaboratore.tipoProfilo : '--'}</Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginTop: -18 }}>
              <Grid.Column width={16}><b style={{ color: '#666' }}>SENIOR: </b> {this.props.processoImprese.nominativoSenior || '--'}</Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginTop: -18 }}>
              <Grid.Column width={16}><b style={{ color: '#666' }}>RESPONSABILE AREA: </b> {this.props.processoImprese.nominativoResponsabileArea || '--'}</Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginTop: -18 }}>
              <Grid.Column width={16}><b style={{ color: '#666' }}>AGENZIA: </b> {this.props.processoImprese.codiceAgenziaKiron || '--'}</Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginTop: -18 }}>
              <Grid.Column width={16}><b style={{ color: '#666' }}>TIPO GESTIONE: </b> {this.props.processoImprese.tipoGestione || '--'}</Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginTop: -18 }}>
              <Grid.Column width={16}><b style={{ color: '#666' }}>TIPO OPERAZIONE: </b> {this.props.processoImprese.tipoProdotto || '--'}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default Infobox;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/Infobox/index.js